import api from "./api";

export const devNoteService = {
  listAll: () => api.get("/dev-notes"),
  listByType: (type) => api.get(`/dev-notes/type/${type}`),
  get: (id) => api.get(`/dev-notes/${id}`),
  create: (data) => api.post("/dev-notes", data),
  update: (id, data) => api.put(`/dev-notes/${id}`, data),
  delete: (id) => api.delete(`/dev-notes/${id}`),
};
